<div class="wrapper">
	<div class="header">
		<fa-icon [icon]="faRedo" class="header__refresh" (click)="refreshClick()"></fa-icon>
		<div class="header__title">{{'network-check.title'|translate}}</div>
		<div class="header__confirm" (click)="close.emit()">{{'commonService.confirm'|translate}}</div>
	</div>
	<div class="content">
		<!--<div class="test">
			<canvas id="chart-test"></canvas>
		</div>-->
		<div class="topic">
			<div class="topic__ping {{datas.lang}}">{{'network-check.ping'|translate}}</div>
			<div class="topic__download {{datas.lang}}">{{'network-check.download'|translate}}</div>
			<div class="topic__upload {{datas.lang}}">{{'network-check.upload'|translate}}</div>
		</div>
		<div class="row" *ngFor="let row of rows">
			<div class="row__title">{{('network-check.' + row.title)|translate}}</div>
			<div class="row__result">
				<div [ngClass]="['row__icon', row.status?row.status:'', row.avgResponse?'':'no-response']"></div>
				<div class="row__time" *ngIf="row.avgResponse">{{row.avgResponse}} ms</div>
				<div class="row__dot" *ngIf="!row.avgResponse && row.pingStarted && row.pingStatus != 'fail'">{{ dot }}</div>
				<div class="row__ping-cant-connect" *ngIf="!row.avgResponse && row.pingStarted && row.pingStatus == 'fail'">{{ 'network-check.cant-connect'|translate }}</div>
			</div>
			<div class="row__chart" *ngIf="row.download && row.downloadStatus && row.downloadStatus != 'fail'" [style.backgroundImage]="row.downloadBg">
				<div class="row__chart__fill download" [style.width.px]="(row.download / 500) * 120"></div>
				<div class="row__chart__bg"></div>
				<canvas class="chart-canvas" id="chart-{{row.title}}-download"></canvas>
			</div>
			<div class="row__speed" *ngIf="row.download && row.downloadStatus && row.downloadStatus != 'fail'">{{row.download + ' Mbps'}}</div>
			<!--<div *ngIf="row.downloadUrl && row.downloadStarted && !row.downloadStatus" class="row__in-progress download">{{ dot }}</div>-->
			<div *ngIf="inProgressConnection == row.title + '-d'" class="row__in-progress download">{{ dot }}</div>
			<div *ngIf="!row.downloadUrl" class="row__in-progress download na">{{ 'network-check.unable-preview'|translate }}</div>
			<div class="row__cant-connect download" *ngIf="inProgressConnection != row.title + '-d' && row.downloadStatus == 'fail'">{{ 'network-check.cant-connect'|translate }}</div>
			
			<div class="row__chart" *ngIf="row.upload && row.uploadStatus && row.uploadStatus != 'fail'" [style.backgroundImage]="row.uploadBg">
				<div class="row__chart__fill upload" [style.width.px]="(row.upload / 500) * 120"></div>
				<div class="row__chart__bg"></div>
				<canvas class="chart-canvas" id="chart-{{row.title}}-upload"></canvas>
			</div>
			<div class="row__speed" *ngIf="row.upload && row.uploadStatus && row.uploadStatus != 'fail'">{{row.upload + ' Mbps'}}</div>
			<!--<div *ngIf="row.uploadUrl && row.uploadStarted && !row.uploadStatus" class="row__in-progress upload">{{ dot }}</div>-->
			<div *ngIf="inProgressConnection == row.title + '-u'" class="row__in-progress upload">{{ dot }}</div>
			<div *ngIf="!row.uploadUrl" class="row__in-progress upload na">{{ 'network-check.unable-preview'|translate }}</div>
			<div class="row__cant-connect upload" *ngIf="inProgressConnection != row.title + '-u' && (row.downloadStatus == 'fail' || row.uploadStatus == 'fail')">{{ 'network-check.cant-connect'|translate }}</div>
		</div>
		<div class="conclusion" *ngIf="showConclusion">
			<span class="type-{{conclusion?conclusion:''}}">{{('network-check.'+ conclusion)|translate}}</span> 
			<span>({{checkTime|mo}})</span>
		</div>
	</div>
</div>
